import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LanguageIcon from "@mui/icons-material/Language";
import BaseButton from "../../../../components/Button";
import { useLanguage } from "../../../../context/LanguageContext";
import styles from "./ListLanguageButton.styles";
import { useLocation } from "react-router-dom";
import { languagePath } from "../../../../i18n/routing";

const ListLanguageButton = () => {
  const { selectedLanguage, translate } = useLanguage();
  const location = useLocation();
  const languages = ["en", "fr", "ar"];
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = {
    open: (event) => setAnchorEl(event.currentTarget),
    close: () => setAnchorEl(null),
  };

  return (
    <div>
      <BaseButton
        text={selectedLanguage.toUpperCase()}
        styling="secondary"
        aria-label={translate(selectedLanguage)}
        aria-controls={anchorEl ? "language-menu" : undefined}
        aria-expanded={anchorEl ? "true" : undefined}
        aria-haspopup="menu"
        handleOnClick={handleMenu.open}
        startIcon={<LanguageIcon />}
        endIcon={<KeyboardArrowDownIcon fontSize="small" />}
        sx={styles.ListLanguageButton_button}
      />
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenu.close}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={styles.ListLanguageButton_menuContainer}
      >
        {languages.map((language) => (
          <MenuItem
            component="a"
            href={languagePath(location.pathname, language) + location.search + location.hash}
            hrefLang={language}
            key={language}
            selected={language === selectedLanguage}
            sx={styles.ListLanguageButton_menuItem}
          >
            <span>{translate(language)}</span>
            {language === selectedLanguage && <CheckIcon fontSize="small" />}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default ListLanguageButton;
